import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import DttsComponent from './dtts.component';

let DttsModule = angular
  .module('Dtts', [
    uiRouter
  ])
  .component('dtts', DttsComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('dtts', {
      url: '/dtts',
      data: {
        authRequired: true,
        permsRequired: ['view-dtt', 'upload-dtt', 'process-dtts']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'dtts',
          bindings: { dttsObservable: 'dttsObservable' }
        }
      },
      resolve: {
        dttsObservable: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-dtt') ? ContentService.getDttsList() : {};
        }
      }
    })
  })
  .name;

export default DttsModule;



// WEBPACK FOOTER //
// ./src/app/pages/dtts/dtts.module.js